module.exports = __webpack_public_path__ + "static/media/pj.a89a69d0.png";